<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item v-if='refreshBtn' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='notices' eventType='refresh'></e-item>
        <e-item v-if='exportBtn' prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Alarm.export")' :click='notices' eventType='export'></e-item>
        <e-item v-if='syncBtn' prefixIcon='icon hero-icon hero-icon-synchronize' :tooltipText='$t("Alarm.synchronize")' :click='notices' eventType='sync'></e-item>
        <e-item v-if='separatorLine'  type='Separator'></e-item>
        <e-item v-if='confirmBtn' prefixIcon='icon hero-icon hero-icon-confirm' :tooltipText='$t("Alarm.confirm")' :click='notices' eventType='confirm'></e-item>
        <e-item v-if='clearBtn' prefixIcon='icon hero-icon hero-icon-clear' :tooltipText='$t("Alarm.clear")' :click='notices' eventType='clear'></e-item>
        <e-item v-if='showDetailBtn' prefixIcon='icon hero-icon hero-icon-alarm-details' :tooltipText='$t("Alarm.alarmDetails")' :click='notices' eventType='showDetail'></e-item>
        <e-item v-if='statisticsBtn' prefixIcon='icon hero-icon hero-icon-statistics' :tooltipText='$t("Alarm.statistics")' :click='notices' eventType='statistics'></e-item>
        <e-item v-if='shieldBtn' prefixIcon='icon hero-icon hero-icon-shield' :tooltipText='$t("Alarm.shield")' :click='notices' eventType='shield'></e-item>
        <e-item v-if='filterBtn' prefixIcon='icon hero-icon hero-icon-filter' :tooltipText='$t("Alarm.filter")' :click='notices' eventType='filter'></e-item>
        <e-item v-if='subscritionBtn' :prefixIcon='subscritionIcon' :tooltipText='$t("Alarm.alertSubscription")' :click='subscritionFunc'></e-item>
        <e-item v-if='autoConfirmBtn' prefixIcon='icon hero-icon hero-icon-auto-confirm' :tooltipText='$t("Alarm.automaticConfirmation")' :click='notices' eventType='autoConfirm'></e-item>
      </e-items>
    </ejs-toolbar>
    <div v-if='keywordsInput' class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("Alarm.pleaseEnterTheQueryCriteria")' :width="320" @input='updateKeywords' @keydown.native.enter='keydownFunc'></ejs-textbox>
    </div>
  </div>
</template>
<script>
export default {
  name: 'currentAlarmButton',
  props: {
    refreshBtn: { type: Boolean, default: false },
    exportBtn: { type: Boolean, default: false },
    syncBtn: { type: Boolean, default: false },
    separatorLine: { type: Boolean, default: false },
    confirmBtn: { type: Boolean, default: false },
    clearBtn: { type: Boolean, default: false },
    showDetailBtn: { type: Boolean, default: false },
    statisticsBtn: { type: Boolean, default: false },
    shieldBtn: { type: Boolean, default: false },
    filterBtn: { type: Boolean, default: false },
    subscritionBtn: { type: Boolean, default: false },
    autoConfirmBtn: { type: Boolean, default: false },
    keywordsInput: { type: Boolean, default: false }
  },
  data() {
    return {
      isOn: '0',
      queryConditions: {
        systemId: 1,
        conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
        keywords: '', // 模糊查询关键字
      }
    };
  },
  computed: {
    subscritionIcon() {
      return this.isOn === '1' ? 'icon hero-icon hero-icon-on' : 'icon hero-icon hero-icon-off';
    }
  },
  methods: {
    notices(args) {
      if (args.item.eventType === 'refresh') {
        this.queryConditions.keywords = '';
      }
      this.$emit('notice', args.item.eventType);
    },
    getSubscritionStatus() {
      // 刷新告警订阅状态 0:off 1:on
      const This = this;
      This.$axios.post('/lte/ems/fm/alarmcurrent/queryIsOn').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.isOn = `${response.data.resultVal.isOn}`;
          This.$emit('isOn', This.isOn);
        }
      });
    },
    subscritionFunc() {
      // 点击告警订阅
      const This = this;
      This.$axios.post('/lte/ems/fm/alarmcurrent/modifyAutoPara').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.isOn = This.isOn === '1' ? '0' : '1';
          This.$emit('isOn', This.isOn);
          if (This.isOn === '1') {
            This.$emit('notice', 'refresh');
          }
        }
      });
    },
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
    },
    keydownFunc() {
      if (this.queryConditions.keywords === '') {
        this.queryConditions.keywords = '';
        this.$emit('notice', 'conditions');
      } else {
        this.$emit('notice', 'keywords');
      }
    }
  },
  mounted() {
    if (this.subscritionBtn) {
      this.getSubscritionStatus();
    }
  }
};
</script>
